const map = {
	"./bank_statements.svg": 19826,
	"./bank_statements_no_bank.svg": 77085,
	"./ethic.svg": 61824,
	"./knf.svg": 63110,
	"./no_statements.svg": 16907,
	"./statements.svg": 9433
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7423;